function e(e, t, n) {
  void 0 === n && (n = {});
  var r = Object.assign({}, n, {
      g: e,
      email: t
    }),
    s = Object.keys(r).reduce(function (e, t) {
      return e.append(t, r[t]), e;
    }, new URLSearchParams());
  return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
    method: "POST",
    headers: {
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
    },
    body: s
  }).then(function (e) {
    return e.json();
  });
}
export { e as subscribe };